import type { PageContext } from "vike/types";

/**
 * Sets `<html lang>` per prerendered locale. vike-react's `lang` head setting
 * takes precedence over `+htmlAttributes` (and defaults to "en"), so the locale
 * must be applied here, as a function of pageContext, or every page ships
 * `lang="en"`.
 */
export default (pageContext: PageContext): string => pageContext.locale ?? "it";
